export default __webpack_public_path__ + "static/Alicante-26bf9f6a9519197d9c332771dd8f3023.jpg";